export class Coupon {
  constructor({ couponCode, couponTitle, couponDescription }) {
    this.code = couponCode;
    this.title = couponTitle;
    this.description = couponDescription;
  }
}

export default Coupon;
